import { render } from "./InvestmentsCard.vue?vue&type=template&id=90f77744&scoped=true"
import script from "./InvestmentsCard.vue?vue&type=script&lang=js"
export * from "./InvestmentsCard.vue?vue&type=script&lang=js"

import "./InvestmentsCard.vue?vue&type=style&index=0&id=90f77744&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-90f77744"

export default script